import resetAtmCodeAllComponent from './reset_atm_code.all.component';

let resetAtmCodeAllModule = angular.module('resetAtmCodeAll', [
  ])

  .component('resetAtmCodeAll', resetAtmCodeAllComponent)

  .name;

export default resetAtmCodeAllModule;


// WEBPACK FOOTER //
// ./client/app/components/reset_atm_code/all/index.js